import { Fragment } from 'react'
import { Box, Tooltip } from '@mui/material'
import type { TooltipProps } from '@mui/material'

/**
 * A `Tooltip` in the house style: black, with a little breathing room from its anchor.
 * A `title` given as an array renders one block per entry.
 *
 * The name is historical — it once hand-built an arrow out of a bordered pseudo-element
 * positioned by Popper. That machinery targeted Popper v1 (`x-placement`, an object of
 * `modifiers`) and JSS (`$arrow`), neither of which survived the v4 → v5 move, so it had
 * long since stopped drawing anything. MUI's own `arrow` prop is the replacement if an
 * arrow is ever wanted back.
 */
const ArrowTooltip = ({ title, ...props }: TooltipProps) => {
  return (
    <Tooltip
      slotProps={{
        tooltip: {
          sx: {
            position: 'relative',
            bgcolor: 'common.black',
            color: 'common.white',
            '&.MuiTooltip-tooltipPlacementLeft, &.MuiTooltip-tooltipPlacementRight': {
              margin: '0 8px',
            },
            '&.MuiTooltip-tooltipPlacementTop, &.MuiTooltip-tooltipPlacementBottom': {
              margin: '8px 0',
            },
          },
        },
      }}
      placement="top"
      {...props}
      title={
        title !== '' ? (
          <Fragment>
            {Array.isArray(title)
              ? title.map((element, index) => (
                  <Box component="div" key={index}>
                    {element}
                  </Box>
                ))
              : title}
          </Fragment>
        ) : (
          ''
        )
      }
      enterDelay={500}
    />
  )
}

export default ArrowTooltip
